import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Router } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'
import { Button } from 'primeng/button'

@Component({
  selector: 'app-not-found-page',
  templateUrl: 'not-found-page.component.html',
  styleUrl: 'not-found-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Button, TranslatePipe],
})
export class NotFoundPageComponent {
  protected readonly router = inject(Router)

  protected backToApp() {
    this.router.navigate(['/'])
  }
}
